import {ObjectBrowserResultEntryDto} from "./object-browser-result-entry.dto";
import {ObjectBrowserRequestDto} from "./object-browser-request.dto";
import {ObjectTypeIdList} from "../../logic/object-type-id-list";
import {ObjectTypeId} from "../../logic/object-type-id";

export class ObjectBrowserResultDto {

    public root: ObjectBrowserResultEntryDto;

    public request: ObjectBrowserRequestDto;



    public findResulEntry(objectType: string, objectId: number) : ObjectBrowserResultEntryDto {
        return this.findResulEntryInternal(this.root, objectType, objectId);
    }

    protected findResulEntryInternal(entry: ObjectBrowserResultEntryDto, objectType: string, objectId: number) : ObjectBrowserResultEntryDto {

        if (entry && !entry.createEntry && entry.objectAlias === objectType && (entry.objectId === objectId || ( !entry.objectId && !objectId))) {
            return entry;
        }

        if (entry.children) {
            for (let child of entry.children) {
                const objectBrowserResultEntryDto = this.findResulEntryInternal(child, objectType, objectId);

                if (objectBrowserResultEntryDto) {
                    return objectBrowserResultEntryDto;
                }
            }
        }

        return null;


    }


    /**
     * Get expanded objects.
     */
    public getExpandedObjects() : ObjectTypeIdList {

        const objectTypeList: ObjectTypeIdList = new ObjectTypeIdList();

        if (this.root) {
            this.collectExpandedObjects(this.root, objectTypeList);
        }

        return objectTypeList;
    }

    protected collectExpandedObjects(entry: ObjectBrowserResultEntryDto, collectObjectTypes: ObjectTypeIdList) {

        if (entry.expanded) {
            collectObjectTypes.add(new ObjectTypeId(entry.objectAlias, entry.objectId));
        }

        if (entry.children) {

            for (let child of entry.children) {
                this.collectExpandedObjects(child, collectObjectTypes);
            }
        }

    }


}
